import { FormFields } from 'app/modules/filingFormGenerator/models';
import {
  selectField,
  textField,
  textareaField,
} from 'app/modules/goAML/formConfig/fields/fieldBuilders';
import { GoamlReferenceTables } from 'app/modules/goAML/queries/useGetGoamlFiuConfig';

type FieldValues = Record<string, any>;

export const getLocationFields = (
  referenceTables: GoamlReferenceTables,
): FormFields<FieldValues> => [
  selectField(
    {
      name: 'address_type',
      label: 'Address type',
      required: true,
      refTable: 'contact_type',
    },
    referenceTables,
  ),
  textField({ name: 'address', label: 'Address', required: true }),
  selectField(
    {
      name: 'country_code',
      label: 'Country code',
      required: true,
      refTable: 'country_code',
    },
    referenceTables,
  ),
  textField({ name: 'state', label: 'State' }),
  textField({ name: 'town', label: 'Town' }),
  textField({ name: 'city', label: 'City', required: true }),
  textField({ name: 'zip', label: 'ZIP' }),
  textareaField({ name: 'comments', label: 'Comments' }),
];
